import { shouldAbortOrderCreationAndRedirectToCaptchaError } from './shouldAbortOrderCreationAndRedirectToCaptchaError';
import { createOrder } from './createOrder';

export const handleCaptchaBeforeCreateOrder =
    (shouldRedirect) => async (dispatch, getState) => {
        if (
            await shouldAbortOrderCreationAndRedirectToCaptchaError(
                dispatch,
                getState(),
            )
        ) {
            return;
        }

        const order = await dispatch(
            createOrder({
                shouldRedirect,
            }),
        );

        return order;
    };
